<template>
  <div class="tpehealth-app-template-pregnancy-gene-page col-block width-full">
    <div class="tpehealth-app-content-gene-table-containr col-block width-full">
      <div class="tpehealth-app-content-gene-table-title-containr row-block">
        <div class="tpehealth-app-content-gene-table-title" :style="{ color: '#C00000' }">{{ '女性相關基因清單'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-gene-table-main-containr col-block width-full">
        <layerTable
          :datas="geneTableDatas['女性']"
          :option="geneTableOption"
        ></layerTable>
      </div>
    </div>
    <div class="tpehealth-app-content-gene-table-containr col-block width-full">
      <div class="tpehealth-app-content-gene-table-title-containr row-block">
        <div class="tpehealth-app-content-gene-table-title" :style="{ color: '#4472C4' }">{{ '男性相關基因清單'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-gene-table-main-containr col-block width-full">
        <layerTable
          :datas="geneTableDatas['男性']"
          :option="geneTableOption"
        ></layerTable>
      </div>
    </div>
  </div>
</template>

<script>
import layerTable from '@/components/tpehealth/layout/layerTable.vue'
import attachmentGenes from '@/components/tpehealth/data/attachmentGenes.json'

export default {
  components: {
    layerTable
  },
  computed: {
    // static
    geneTableDatas () {
      return attachmentGenes
    },
    geneTableOption () {
      return {
        style: 'striped',
        options: [
          {
            title: '基因名稱'/* ___ */,
            width: '100px',
            value: data => data['基因名稱']
          },
          {
            title: '疾病名稱'/* ___ */,
            col: 'start',
            value: data => data['疾病名稱']
          },
          {
            title: '遺傳模式'/* ___ */,
            width: '150px',
            value: data => data['遺傳模式']
          }
        ]
      }
    }
  }
}
</script>
